'use client';

import React, { useState, useEffect } from 'react';
import Link from 'next/link';

const navLinks = [
  { label: 'Beranda', href: '#beranda' },
  { label: 'Layanan', href: '#layanan' },
  { label: 'Keunggulan', href: '#keunggulan' },
  { label: 'Kontak', href: '#kontak' },
];

export default function HomeHeader() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  useEffect(() => {
    document.body.style.overflow = menuOpen ? 'hidden' : '';
    return () => { document.body.style.overflow = ''; };
  }, [menuOpen]);

  const handleNav = (href: string) => {
    setMenuOpen(false);
    document.querySelector(href)?.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <>
      <header
        className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
          scrolled
            ? 'bg-[rgba(9,9,11,0.85)] backdrop-blur-[12px] border-b border-white/[0.06] shadow-[0_2px_20px_rgba(0,0,0,0.4)]'
            : 'bg-transparent'
        }`}
      >
        <div className="max-w-7xl mx-auto px-6 md:px-10 flex items-center justify-between h-16 md:h-20">
          <button onClick={() => handleNav('#beranda')} className="flex items-center gap-2.5">
            <img src="/logo.png" alt="STUDO.ID" className="h-8 w-8 object-contain" />
            <span className="text-white font-bold text-lg tracking-tight">
              STUDO<span style={{ color: '#8cc63f' }}>.ID</span>
            </span>
          </button>

          <nav className="hidden md:flex items-center gap-8">
            {navLinks.map(link => (
              <button key={link.href} onClick={() => handleNav(link.href)}
                className="text-[13px] font-medium text-zinc-400 hover:text-white transition-colors tracking-wide">
                {link.label}
              </button>
            ))}
          </nav>

          <div className="hidden md:flex items-center gap-3">
            <Link href="/login"
              className="px-6 py-2.5 text-[13px] font-semibold bg-white text-zinc-900 hover:bg-[#a3e635] hover:text-white transition-all duration-150"
            >
              Masuk Dashboard
            </Link>
          </div>

          <button className="md:hidden flex flex-col gap-[5px] p-2" onClick={() => setMenuOpen(!menuOpen)}>
            <span className={`block w-6 h-[1.5px] bg-white transition-all duration-300 ${menuOpen ? 'rotate-45 translate-y-[6.5px]' : ''}`} />
            <span className={`block w-6 h-[1.5px] bg-white transition-all duration-150 ${menuOpen ? 'opacity-0' : ''}`} />
            <span className={`block w-6 h-[1.5px] bg-white transition-all duration-300 ${menuOpen ? '-rotate-45 -translate-y-[6.5px]' : ''}`} />
          </button>
        </div>
      </header>

      {/* Mobile overlay */}
      <div className={`fixed inset-0 z-40 transition-all duration-300 md:hidden ${menuOpen ? 'opacity-100 pointer-events-auto' : 'opacity-0 pointer-events-none'}`}>
        <div className="absolute inset-0 bg-[rgba(9,9,11,0.96)] backdrop-blur-[20px]" onClick={() => setMenuOpen(false)} />
        <nav className="relative z-10 flex flex-col items-center justify-center h-full gap-8">
          {navLinks.map(link => (
            <button key={link.href} onClick={() => handleNav(link.href)}
              className="text-2xl font-semibold text-white/80 hover:text-white transition-colors">
              {link.label}
            </button>
          ))}
          <Link href="/login" className="mt-4 px-10 py-4 bg-white text-zinc-900 font-semibold text-base">
            Masuk Dashboard
          </Link>
        </nav>
      </div>
    </>
  );
}
